import React from "react";

const SelectFilter = ({
                          label = "Center Type",
                          id = "inputState", options = ["..."],
                          pInput,
                          value="",
                          onChange
}) => {

    return (
        <div className="mb-3">
            <label htmlFor={id} className="form-label fs-6">{label}</label>
            <select
                id={id}
                className={`form-select bg-light border-light shadow-none py-2 rounded text-muted ${pInput}`}
                defaultValue=""
                value={value}
                onChange={onChange}
            >
                <option value="" disabled hidden>Select</option>
                {options.map((option, index) => (
                    <option key={index} value={option}>{option}</option>
                ))}
            </select>
        </div>
    );
};

export default SelectFilter;